export default "__VITE_ASSET__zIVY12Ec__"